var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4683_20365)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1562 6.94531C12.3634 6.94531 12.5312 7.11321 12.5312 7.32031V8.94533H14.6562C14.8634 8.94533 15.0312 9.11322 15.0312 9.32033C15.0312 9.52744 14.8634 9.69533 14.6562 9.69533H12.5312V12.4453H13.4062C13.9698 12.4453 14.5103 12.6692 14.9089 13.0677C15.3074 13.4662 15.5312 14.0067 15.5312 14.5703C15.5312 15.1339 15.3074 15.6744 14.9089 16.0729C14.5103 16.4714 13.9698 16.6953 13.4062 16.6953H12.5312V18.3203C12.5312 18.5274 12.3634 18.6953 12.1562 18.6953C11.9491 18.6953 11.7812 18.5274 11.7812 18.3203V16.6953H9.15625C8.94914 16.6953 8.78125 16.5274 8.78125 16.3203C8.78125 16.1132 8.94914 15.9453 9.15625 15.9453H11.7812V13.1953H10.9062C10.3427 13.1953 9.80216 12.9714 9.40365 12.5729C9.00513 12.1744 8.78125 11.6339 8.78125 11.0703C8.78125 10.5067 9.00513 9.96624 9.40365 9.56773C9.80216 9.16921 10.3427 8.94533 10.9062 8.94533H11.7812V7.32031C11.7812 7.11321 11.9491 6.94531 12.1562 6.94531ZM11.7812 9.69533H10.9062C10.5416 9.69533 10.1918 9.84019 9.93398 10.0981C9.67612 10.3559 9.53125 10.7057 9.53125 11.0703C9.53125 11.435 9.67612 11.7847 9.93398 12.0426C10.1918 12.3005 10.5416 12.4453 10.9062 12.4453H11.7812V9.69533ZM12.5312 13.1953V15.9453H13.4062C13.7709 15.9453 14.1207 15.8005 14.3785 15.5426C14.6364 15.2847 14.7812 14.935 14.7812 14.5703C14.7812 14.2057 14.6364 13.8559 14.3785 13.5981C14.1207 13.3402 13.7709 13.1953 13.4062 13.1953H12.5312Z",
  fill: "#00538F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4683_20365"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(6.15625 6.82031)"
})));

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9432fae6.svg";
export { ForwardRef as ReactComponent };